import { useQuery } from '@tanstack/react-query';
import { preRegistrationApi } from '../api/pre-registration.api';
import { preRegistrationKeys } from './usePreRegistrationQueries';

// Localities of one municipality; disabled until a municipality is selected
export const useMunicipalityLocalities = (municipalityId?: number) => {
  return useQuery({
    queryKey: preRegistrationKeys.municipalityLocalities(municipalityId ?? 0),
    queryFn: () => preRegistrationApi.getLocalitiesByMunicipality(municipalityId as number),
    enabled: !!municipalityId,
    staleTime: Infinity,
  });
};
